import { render, staticRenderFns } from "./AsorRbuConfig.vue?vue&type=template&id=3dfc8c13"
import script from "./AsorRbuConfig.vue?vue&type=script&lang=js"
export * from "./AsorRbuConfig.vue?vue&type=script&lang=js"
import style0 from "./AsorRbuConfig.vue?vue&type=style&index=0&id=3dfc8c13&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports